import * as React from "react";
import { Select } from "antd";
const Option = Select.Option;
import { connect } from "react-redux";

interface ISecondCategoriesProps {
  width?: number;
  value?: any;
  share?: any;
  modelName?: any;
  "data-field"?: any;
  setValue?: any;
  onChange?: any;
}

// 订单来源 二级类目组件
class SecondCategories extends React.Component<ISecondCategoriesProps, any> {
  constructor(props: ISecondCategoriesProps) {
    super(props);
  }

  // 更改二级类目选择项时触发
  // e:更改后的值
  onChangeSecondCategories = e => {
    // 提供在更改订单来源二级分类时触发其它功能的钩子函数
    // e:更改的值 field:二级分类字段
    this.props.onChange && this.props.onChange(e, this.props["data-field"]);
  };

  render() {
    const list = this.props.share.secondCategories;
    const mapList = () => {
      let options: any = [];
      for (const item of list) {
        options.push(
          <Option key={item.id} value={item.id}>
            {item.name}
          </Option>
        );
      }
      return options;
    };
    // 当数据已加载完成时才设置选中的值,这样处理可以避免由于数据集为加载而造成的闪烁
    const value = this.props.share.secondCategories.length
      ? this.props.value || undefined
      : undefined;

    // 根据关键字检索option
    const filter = (input, option) =>
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    return (
      <Select
        style={{ width: this.props.width || 200 }}
        value={value}
        allowClear={true}
        placeholder="选择二级来源"
        onChange={this.onChangeSecondCategories}
        // 检索相关
        showSearch
        optionFilterProp="children"
        filterOption={filter}
        // 检索相关
      >
        {mapList()}
      </Select>
    );
  }
}

const mapState = state => ({
  share: state.share
});

export default connect(
  mapState,
  null
)(SecondCategories);
